var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContent db-page"},[_c('div',{staticClass:"top-control"},[_c('div',{staticClass:"tab-content"})])])
}]

export { render, staticRenderFns }